import React from 'react';
// Helpers
import useI18n from '@i18n';

// Styles
import styles from './Header.module.scss';

interface IHeaderProps {
    formLink: string;
}

const WebmasterHeader: React.FC<IHeaderProps> = () => {
    const { t } = useI18n('Cpa');

    return (
        <section className={styles.Header}>
            <div className={styles.landingContainer}>
                <div className={styles.Header__wrapper}>
                    <div className={styles.Header__content}>
                        <h1 className={styles.Header__title}>
                            {t('e-Commerce Partners Network — helps increase sales')}
                        </h1>
                        <div className={styles.Header__subTitle}>
                            Want to increase sales and bring in more clients? <br /> Apply now.
                        </div>
                        <div>
                            {/* <WhiteButton
                                block={false}
                                transparent={false}
                                href={`/${locale}/affiliate/application`}
                                className={styles.Header__button}
                            >
                                <span>
                                    {t('Make a request')}
                                    <FontAwesomeIcon
                                        icon={faArrowRight}
                                        className={styles.Header__buttonIcon}
                                    />
                                </span>
                            </WhiteButton> */}
                        </div>
                    </div>
                    <div className={styles.Header__image} />
                </div>
            </div>
        </section>
    );
};

export default WebmasterHeader;
